const state = {

    fineChatClient : null,
    apiUrl : null,
    apiToken : null,

    selectedChatUid: null,
    selectedChat : {},
    user : {}
  // Devices

}

const actions = {

    async GET_CHAT_AUTH_TOKEN({dispatch,rootState}) {
        return await dispatch('ajax/SEND_NEW',
            {
                route:`webinar/chat/auth`,
                method:'GET',
                business : rootState.business.selectedBusiness.alias,
            },{ root : true });
    },

}


export default {
  namespaced:true,
    state,
    actions,
}
